export const translations = {
  ja: {
    // Hero Section
    hero: {
      headline: "一人じゃない。",
      subheadline: "毎日、誰かと繋がる",
      description: "一人暮らし？ワンタップで大切な人に「元気です」を伝えよう。",
      cta: "早期アクセスを取得",
      monthlyPrice: "月額 ¥800"
    },
    
    // Problem Section
    problem: {
      title: "一人暮らしでも、誰かがあなたのことを気にかけている",
      stat1: "日本の世帯の約40%が単身世帯",
      stat2: "孤独死は年間4,000人以上に影響",
      description: "あなたは自立している。でも、誰かがあなたを心配している。",
      notSurveillance: "監視ではありません。ただの繋がりです。"
    },
    
    // How It Works
    howItWorks: {
      title: "使い方",
      step1: {
        title: "毎日「元気です」をタップ",
        description: "シンプルなボタン。カスタマイズ可能なメッセージ。"
      },
      step2: {
        title: "選んだ人に通知が届く",
        description: "家族、友人、またはあなたが選んだ誰でも。"
      },
      step3: {
        title: "24時間以内にチェックインしない場合、自動的にアラート",
        description: "安心のための安全網。"
      }
    },
    
    // Who It's For
    whoItsFor: {
      title: "誰のため？",
      persona1: {
        title: "一人暮らしの方",
        description: "アパートで一人暮らし。誰かが気にかけてくれている。"
      },
      persona2: {
        title: "出張が多い方",
        description: "仕事で旅行中？家族に安心を。"
      },
      persona3: {
        title: "心配する家族がいる方",
        description: "親や友人が心配している？簡単なチェックイン。"
      },
      persona4: {
        title: "お互いに確認し合う友人",
        description: "友人同士で安否確認。"
      }
    },
    
    // Pricing
    pricing: {
      title: "シンプルな料金体系",
      monthlyPrice: "月額 ¥800",
      comparison: "ハードウェアセンサーは月額 ¥2,000以上",
      earlyBird: {
        title: "先着100名様限定",
        discount: "創設メンバー特別価格",
        discountedPrice: "月額 ¥500"
      },
      ctaButton: "早期アクセスに登録",
      ctaNote: "2026年3月にローンチ"
    },
    
    // FAQ
    faq: {
      title: "よくある質問",
      q1: {
        question: "チェックインを忘れたらどうなりますか？",
        answer: "24時間後、選択した連絡先に自動的にアラートが送信されます。誤報を防ぐために、リマインダー通知も送信されます。"
      },
      q2: {
        question: "誰が私のチェックインを見ることができますか？",
        answer: "あなたが選択した人だけです。完全にプライベートです。最大5人の連絡先を追加できます。"
      },
      q3: {
        question: "日本国外でも機能しますか？",
        answer: "はい！インターネット接続があればどこでも動作します。旅行者や出張者に最適です。"
      },
      q4: {
        question: "iOSとAndroidの両方で利用できますか？",
        answer: "はい、2026年3月にローンチ予定です。早期アクセスにサインアップしてください。"
      },
      q5: {
        question: "個人情報は安全ですか？",
        answer: "あなたのデータは暗号化され、日本のサーバーに保存されます。第三者に販売したり共有したりすることはありません。"
      }
    },
    
    // Email Capture
    emailCapture: {
      title: "早期アクセスを取得",
      subtitle: "先着100名様は創設メンバー価格を取得",
      launchDate: "2026年3月にローンチ予定",
      form: {
        name: "お名前",
        email: "メールアドレス",
        phone: "電話番号（任意）",
        segment: "あなたについて教えてください",
        segments: {
          solo: "一人暮らしの方",
          traveler: "旅行者",
          professional: "若手プロフェッショナル",
          other: "その他"
        },
        wouldPay: "月額¥500でこのサービスを利用したいですか？",
        wantInterview: "15分間のインタビューにご協力いただけますか？（ニーズについて詳しく伺います）",
        submit: "早期アクセスを取得",
        submitting: "送信中...",
        success: "ありがとうございます！すぐにご連絡いたします。"
      }
    },
    
    // Footer
    footer: {
      tagline: "一人じゃない。",
      privacy: "プライバシーポリシー",
      terms: "利用規約",
      contact: "お問い合わせ"
    }
  },
  
  en: {
    // Hero Section
    hero: {
      headline: "You're not alone.",
      subheadline: "Stay connected, every day",
      description: "Living alone? One tap to let someone know you're okay.",
      cta: "Get Early Access",
      monthlyPrice: "¥800/month"
    },
    
    // Problem Section
    problem: {
      title: "Living alone, but someone cares about you",
      stat1: "~40% of Japanese households are single-person",
      stat2: "Kodokushi affects 4,000+ annually",
      description: "You're independent. But someone worries about you.",
      notSurveillance: "Not surveillance. Just connection."
    },
    
    // How It Works
    howItWorks: {
      title: "How It Works",
      step1: {
        title: 'Tap "I\'m here" once daily',
        description: "Simple button. Customizable message."
      },
      step2: {
        title: "Your chosen person gets notified",
        description: "Family, friend, or anyone you choose."
      },
      step3: {
        title: "If you miss 24hrs, they're alerted automatically",
        description: "A safety net for peace of mind."
      }
    },
    
    // Who It's For
    whoItsFor: {
      title: "Who It's For",
      persona1: {
        title: "Solo apartment dwellers",
        description: "Living alone in your apartment. Someone cares."
      },
      persona2: {
        title: "People traveling for work",
        description: "On the road? Give family peace of mind."
      },
      persona3: {
        title: "Anyone whose family worries",
        description: "Parents or friends concerned? Easy check-in."
      },
      persona4: {
        title: "Friends keeping tabs on each other",
        description: "Mutual safety checks between friends."
      }
    },
    
    // Pricing
    pricing: {
      title: "Simple Pricing",
      monthlyPrice: "¥800/month",
      comparison: "vs ¥2,000+ for hardware sensors",
      earlyBird: {
        title: "First 100 People Only",
        discount: "Founding member special price",
        discountedPrice: "¥500/month"
      },
      ctaButton: "Get Early Access",
      ctaNote: "Launching March 2026"
    },
    
    // FAQ
    faq: {
      title: "Frequently Asked Questions",
      q1: {
        question: "What if I forget to check in?",
        answer: "After 24 hours, your chosen contacts get an automatic alert. We'll also send you reminder notifications to prevent false alarms."
      },
      q2: {
        question: "Who can see my check-ins?",
        answer: "Only people you choose. Completely private. You can add up to 5 contacts."
      },
      q3: {
        question: "Does it work outside Japan?",
        answer: "Yes! Works anywhere with internet connection. Perfect for travelers or people on business trips."
      },
      q4: {
        question: "iOS and Android?",
        answer: "Yes, both launching March 2026. Sign up for early access."
      },
      q5: {
        question: "Is my data secure?",
        answer: "Your data is encrypted and stored on Japanese servers. We never sell or share with third parties."
      }
    },
    
    // Email Capture
    emailCapture: {
      title: "Get Early Access",
      subtitle: "First 100 people get founding member pricing",
      launchDate: "Launching March 2026",
      form: {
        name: "Your Name",
        email: "Email Address",
        phone: "Phone Number (Optional)",
        segment: "Tell us about yourself",
        segments: {
          solo: "Solo dweller",
          traveler: "Traveler",
          professional: "Young professional",
          other: "Other"
        },
        wouldPay: "Would you pay ¥500/month for this service?",
        wantInterview: "Would you be interested in a 15-minute interview about your needs?",
        submit: "Get Early Access",
        submitting: "Submitting...",
        success: "Thank you! We'll be in touch soon."
      }
    },
    
    // Footer
    footer: {
      tagline: "You're not alone.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      contact: "Contact"
    }
  }
};
